module.exports = __webpack_public_path__ + "assets/img/Pioneer_001.006a07a3-ps.jpg";